import type { FormFieldUICopy } from '@polyai/ui/uiCopy/types';

const FORM_UI_COPY: {
  name: FormFieldUICopy & {
    error: {
      required: string;
    };
  };
  type: FormFieldUICopy;
  description: FormFieldUICopy & {
    error: {
      required: string;
    };
  };
  phoneNumber: {
    toggle: {
      helpText: string;
    };
  };
  alphanumeric: {
    toggle: {
      helpText: string;
    };
  };
} = {
  name: {
    error: {
      required: 'Name is required',
    },
  },
  type: {
    label: 'Type',
    placeholder: 'Select...',
  },
  description: {
    label: 'LLM description',
    placeholder: 'Type in',
    helpText:
      'Provide instructions for the LLM on how to collect this entity, including any rules for validating its format.',
    error: {
      required: 'Description is required',
    },
  },
  phoneNumber: {
    toggle: {
      helpText:
        'All country codes are collected by default. Enable your Agent to validate specific country codes for your use cases',
    },
  },
  alphanumeric: {
    toggle: {
      helpText:
        'Use a regular expression to determine the correct validation for the extracted entity',
    },
  },
} as const;

const ENTITY_TYPE_OPTIONS_UI_COPY = {
  alphanumeric: 'Alphanumeric',
  number: 'Number',
  string: 'String',
  integer: 'Integer',
  boolean: 'Boolean',
  phone_number: 'Phone Number',
  date: 'Date',
  time: 'Time',
  free_text: 'Free Text',
  multiple_choice: 'Multiple Choice',
  name: 'Name',
  address: 'Address',
  currency: 'Currency',
  quantity: 'Quantity',
} as const;

const BUTTON_UI_COPY = {
  close: 'Close',
} as const;

const ERROR_UI_COPY = {
  createFailed: 'Failed to create entity',
  updateFailed: 'Failed to update entity',
} as const;

export const ENTITY_SIDEBAR_UI_COPY = {
  form: FORM_UI_COPY,
  entityTypeOptions: ENTITY_TYPE_OPTIONS_UI_COPY,
  button: BUTTON_UI_COPY,
  error: ERROR_UI_COPY,
} as const;
